import { ReactNode } from "react";

export { KpiChip } from "../Dashboard/DashboardKpiStrip";
export type { KpiAccent } from "../Dashboard/DashboardKpiStrip";

export type PillTone = "success" | "warning" | "danger" | "info" | "neutral" | "muted";

const PILL_TONES: Record<PillTone, string> = {
  success: "bg-theme-success text-white",
  warning: "bg-theme-warning text-white",
  danger: "bg-theme-danger text-white",
  info: "bg-theme-info text-white",
  neutral: "bg-theme-surface text-theme-text border border-theme-border",
  muted: "bg-theme-text-muted text-white",
};

export const Pill = ({ tone, children }: { tone: PillTone; children: ReactNode }) => (
  <span className={`text-xs px-2 py-0.5 rounded-full font-bold leading-none inline-flex items-center gap-1 whitespace-nowrap ${PILL_TONES[tone]}`}>{children}</span>
);
